import React, { useEffect, useState } from 'react';

import { useAnalyticsContext } from 'app/shared/utils';
import { Box } from 'app/shared/components/atoms';
import { useExpressCheckoutContext } from 'app/fan/context/ExpressCheckout';
import { PromoCodeInput } from 'app/fan/components/organisms';

export const PromoCodeForm = () => {
  const [inputValue, setInputValue] = useState('');
  const {
    numberOfTickets,
    promoCodeValue: {
      promoCodeStatus,
      promoCodeErrorMessage,
      validatePromoCode,
      resetValidated,
      wasValidatePromoCodeCalled,
      setClearPromoCodeCallback,
      clearPromoCode,
    },
  } = useExpressCheckoutContext();

  useEffect(() => {
    setClearPromoCodeCallback(() => () => setInputValue(''));
  }, [setClearPromoCodeCallback]);

  const { trackAnalyticsEvent } = useAnalyticsContext();

  const onClickApplyPromoCode = () => {
    trackAnalyticsEvent('Promo code entered', {
      checkout_version: 2,
      promoCodeStatus,
      inputValue,
      is_express_checkout: true,
      is_guest_checkout: false,
      is_guest_user: false,
      event_page_version: 2,
    });
    validatePromoCode(inputValue, numberOfTickets);
  };

  return (
    <Box>
      <PromoCodeInput
        isExpressCheckout={true}
        inputValue={inputValue}
        setInputValue={setInputValue}
        promoCodeStatus={promoCodeStatus}
        resetValidated={resetValidated}
        onClickApplyPromoCode={onClickApplyPromoCode}
        canRedeemAndIsRedeemingVisaFreeTicket={false}
        onPromoCodeRemove={clearPromoCode}
        promoCodeErrorMessage={promoCodeErrorMessage}
        wasValidatePromoCodeCalled={wasValidatePromoCodeCalled}
      />
    </Box>
  );
};
